import { CFImage, CFVideo } from '../../type/client-index'

export const Image1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/c56d56fc-e786-4006-b355-c3e9818b8400/1500',
  width: 1000,
  height: 1500
}

export const Image2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/d404e156-f8a5-4c1b-1bab-b193f4dddb00/1500',
  width: 1000,
  height: 1500
}

export const Logo: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/11a50cd4-6269-4362-c032-48d9587c5400/1500',
  width: 1500,
  height: 1500
}

export const Pattern: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/3bb5411f-07ea-47dc-2112-ec6e00290500/1000',
  width: 1000,
  height: 966
}

export const CarteVisite: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/61c5f9c7-1122-4e5b-d701-0b6e7f883b00/1750',
  width: 1750,
  height: 1077
}

export const StoriesTemplate: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/7f513b38-1df3-40ef-ccfc-1a3fe0ae5d00/1750',
  width: 1750,
  height: 1416
}

// POSTS

export const Post1: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/43df0e78-0ea2-4d57-2e7f-32149a31d200/1500',
  width: 1400,
  height: 1400
}

export const Post2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/1d853173-1b43-43df-0bae-72cbcb872c00/1500',
  width: 1400,
  height: 1400
}

export const Post3: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/38e0820e-c26e-4c00-ba52-620f27cbd700/1500',
  width: 1400,
  height: 1396
}

export const Post4: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/e93ebb90-c188-4125-95c9-b23ea450ab00/1500',
  width: 1400,
  height: 1400
}

export const Post5: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/ef903796-2c65-4809-d1f2-c0d649742c00/1500',
  width: 1400,
  height: 1400
}

export const Post6: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/67e31a19-a9a7-472f-e14b-2aeefe131e00/1500',
  width: 1400,
  height: 1400
}

export const Site: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/fb814ba0-011b-430f-560f-c3739ff0a200/3000',
  width: 3000,
  height: 1767
}

export const ShootLS: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/5275d023-a432-498a-1786-cb7a33c26900/1500',
  width: 1000,
  height: 1500
}

export const ShootLS2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/62750941-4579-47e9-1ccc-2b1de43fcb00/1500',
  width: 1000,
  height: 1500
}

export const ShootDA: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/f285e5cb-4a4e-4316-569d-b17108f8d600/1500',
  width: 1000,
  height: 1500
}

export const ShootDA2: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/d3fc9742-7847-49ce-c0ad-d54dbde66700/1500',
  width: 1000,
  height: 1500
}
